import http from '../http';
import { ROLE, PROJECT } from '@/constants';

class AchievementService {
    getListCategory(roles: string[], selectedCompanyId: string|undefined) {
        let wasteCompanyId = undefined;
        if(roles.some((role) => role === ROLE.TRANSPORT) && (selectedCompanyId != null && selectedCompanyId != 'ALL')) {
            wasteCompanyId = Number(selectedCompanyId);
        }
        let params = '';
        if(wasteCompanyId != undefined) {
            params += `?wasteCompanyId=` + wasteCompanyId;
        }
        if(roles.some((role) => role === ROLE.TRANSPORT)) {
            return http.get(`trans/achievement/waste-type` + params);
        } else
            return http.get(`achievement/waste-type` + params);
    }

    getListIndustryWaste() {
        return http.get(`achievement/waste-type`);
    }

    getListAchievement(roles: string[], mode:string, wasteType: number|undefined, wasteCode: string|undefined, wasteCompanyId: number|undefined) {
        let params = {
            isViewMonthly: mode == 'monthly',
            wasteType: wasteType,
            wasteCode: wasteCode,
            wasteCompanyId: wasteCompanyId
        }
        if(roles.some((role) => role === ROLE.TRANSPORT)) {
            return http.post(`trans/achievement/list`, params);
        } else if(roles.some((role) => role === ROLE.WASTE)) {
            return http.post(`achievement/list`, params);
        }
    }

    getListProjectTitle(type:string, selectedCompanyId: string|undefined):any {
        let wasteCompanyId = undefined;
        if (selectedCompanyId != null && selectedCompanyId != 'ALL') {
            wasteCompanyId = Number(selectedCompanyId);
        }
        let params = '';
        if(wasteCompanyId != undefined) {
            params += `?wasteCompanyId=` + wasteCompanyId;
        }
        if(PROJECT.TYPE.INDUSTRIAL === type) {
            return http.get(`trans/achievement/industry/projects` + params);
        } else {
            return http.get(`trans/achievement/regular/projects` + params);
        }
    }

    getListCollectionDate(projectId:any):any {
        return http.get(`achievement/collection-date?projectId=` + projectId);
    }

    getListCollectionMonth(projectId:any):any {
        return http.get(`achievement/collection-month?projectId=` + projectId);
    }

    getListWasteName(projectId:any, collectionDate:any):any {
        return http.get(`trans/achievement/waste?projectId=` + projectId + `&collectionDate=` + collectionDate);
    }

    getCollectionDateIndustry(projectId:any):any {
        return http.get(`trans/achievement/industry/collection-date?projectId=` + projectId);
    }

    getAchievementDetail(roles:string[], year?:string, month?:string, wasteType?:number, wasteCode?:string, wasteCompanyId?: number, transportCompanyId?:number) {
        let params = {
            year: year,
            month: month,
            wasteType: wasteType,
            wasteCode: wasteCode,
            wasteCompanyId: wasteCompanyId,
            transportCompanyId: transportCompanyId
        }
        if(roles.some((role) => role === ROLE.TRANSPORT)) {
            return http.post(`trans/achievement/detail`, params);
        } else if(roles.some((role) => role === ROLE.WASTE)) {
            return http.post(`achievement/detail`, params);
        }
    }

    reportCompleteTransportGeneralWaste(data:any) {
        return http.post(`trans/achievement/regular`, data);
    }

    reportCompleteTransportIndustryWaste(data:any) {
        return http.post(`trans/achievement/industry`, data);
    }

    getAchievementWasteRegularDetail(id:number) {
        return http.get(`trans/achievement/regular-detail?id=` + id);
    }

    updateAchievementWasteRegular(id:number, volume:number) {
        return http.put(`trans/achievement/regular`, {
            id: id,
            volume: volume
        });
    }

    deleteAchievementRegular(id:number) {
        return http.delete(`trans/achievement/regular?id=` + id);
    }

    getAchievementWasteIndustryDetail(id:number) {
        return http.get(`achievement/industry?id=` + id);
    }

    updateAchievementIndustry(data:any) {
        return http.put(`trans/achievement/industry`, data);
    }

    deleteAchievementIndustry(id:number) {
        return http.delete(`trans/achievement/industry?id=` + id);
    }

    updateAchievementIndustryStatus(id:number, status:string) {
        return http.put(`achievement/industry/status`, {
            id: id,
            status: status
        });
    }

    getVolumeInfo(projectId:string|null, month:string|null) {
        return http.get(`trans/achievement/regular/volume?projectId=` + projectId + `&month=` + month);
    }

    downloadCsv(data:any[], fileName:string, title:string|null) {
        const csvRows: string[] = [];

        if(title != null) {
            csvRows.push(title);
        }

        // Get the headers from the keys of the first object
        const headers = Object.keys(data[0]);
        csvRows.push(headers.join(',')); // Add headers row

        // Add each row of data
        data.forEach(row => {
            const values = headers.map(header => {
            const escaped = String(row[header]).replace(/"/g, '""'); // Escape double quotes
            return `"${escaped}"`; // Wrap each value in double quotes
            });
            csvRows.push(values.join(',')); // Join values with commas
        });

        const csvData = csvRows.join('\n'); // Join rows with newlines

        // Add UTF-8 BOM to ensure correct encoding
        const bom = "\uFEFF";  // Byte Order Mark (BOM)

        // Create a Blob with the CSV data and the correct MIME type
        const blob = new Blob([bom + csvData], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);

        // Create a link element
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName; // Set the file name

        // Trigger the download by simulating a click
        link.click();

        // Clean up the URL object
        setTimeout(() => {
            window.URL.revokeObjectURL(url);
        }, 100);
    }

    convertWeight(value: string):string {
        if(value == null) {
            return '0.00';
        }
        value = Intl.NumberFormat('ja-JP').format(Number.parseFloat(value));
        let dotIndex = value.indexOf('.');
        let strArr:string[] = value.split('.');
        if(dotIndex == -1) {
            value = value + '.00';
        } else {
            if(strArr[1].length == 0) {
                value = value + '00';
            } else if(strArr[1].length == 1) {
                value = value + '0';
            }
        }
        return value;
    }

    convertWeightInteger(value: string):string {
        if(value == null) {
            return '0';
        }
        return Intl.NumberFormat('ja-JP').format(Number.parseInt(value));
    }

    onChangeTransportVolume(value: string):string {
        if(value == '') {
            value = '0.00';
        } else if(!value.startsWith('0.') && value != '0') {
            value = value.replace(/^0+/, '');
            if(value.startsWith('.')) {
                value = '0' + value;
            }
        }
        return value;
    }

    validateVolume(value: string):boolean {
        if(!value) {
            return false;
        }
        const regex1 = /^\d{1,5}(\.\d{0,2})?$/;
        const regex2 = /^\d{1,7}$/;
        if(!regex1.test(value.replaceAll(/,/g, '')) && !regex2.test(value.replaceAll(/,/g, ''))) {
            return false;
        } else {
            return true;
        }
    }

    getCreationStatus(selectedCompanyId: string|undefined) {
        let wasteCompanyId = undefined;
        if (selectedCompanyId != null && selectedCompanyId != 'ALL') {
            wasteCompanyId = Number(selectedCompanyId);
        }
        let params = '';
        if(wasteCompanyId != undefined) {
            params += `?wasteCompanyId=` + wasteCompanyId;
        }
        return http.get(`trans/achievement/creation/status` + params);
    }

    getListCompanyForReport(type:string):any {
        if(PROJECT.TYPE.INDUSTRIAL === type) {
            return http.get(`trans/achievement/industry/companies`);
        } else {
            return http.get(`trans/achievement/regular/companies`);
        }
    }

    getListMeasureUnit():any {
        return http.get(`achievement/measure-unit`);
    }

    getListDisposalMethod():any {
        return http.get(`achievement/disposal-method`);
    }

    getCurrentTimeInJapan():string {
        return new Intl.DateTimeFormat('en-US', {
            timeZone: 'Asia/Tokyo',
            hour: '2-digit',
            hour12: false,
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date());
    }

    calculateTotalSecond(timeStr: string):number {
        let timeArr = timeStr.split(':').map(Number);
        return timeArr[0] * 3600 + timeArr[1] * 60 + timeArr[2];
    }
}

export default new AchievementService();